var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("👍 Compre ou Venda 👎")]),_c('ProdutosBuscar'),_c('ProdutosLista')],1)}
var staticRenderFns = []

export { render, staticRenderFns }